import React from 'react'
import { useParams } from 'react-router-dom';
import CasePage from './CasePage';

// /attorney/caseDetails/:id - full case page (Case List handoff §7b)
function ProfCaseDetails() {
  const {id} = useParams();
  return <CasePage key={id} caseId={id} />;
}

export default ProfCaseDetails
